// extracted by css-extract-rspack-plugin
export default {"cls1":"ImpactNavBar-cls1_wBF","cls2":"ImpactNavBar-cls2_H7V ImpactNavBar-cls1_wBF","tone-grey":"ImpactNavBar-tone-grey__IJ"};